import { useCallback, useEffect, useState } from "react";
import { apiJson } from "../../utils/api.js";

function pill(text) {
  return <div className="pill">{text}</div>;
}

export function FunnelBroadcastSection() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [funnels, setFunnels] = useState([]);
  const [funnelId, setFunnelId] = useState("");
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const loadFunnels = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiJson("/api/admin/broadcast/funnels");
      const items = data?.items || [];
      setFunnels(items);
      if (items.length && !funnelId) {
        setFunnelId(String(items[0].id));
      }
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setFunnels([]);
    } finally {
      setLoading(false);
    }
  }, [funnelId]);

  useEffect(() => {
    loadFunnels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selected = funnels.find((f) => String(f.id) === String(funnelId));
  const recipients = Number(selected?.recipients) || 0;

  async function handleSend() {
    const t = text.trim();
    if (!funnelId) {
      window.alert("Выберите воронку");
      return;
    }
    if (!t) {
      window.alert("Введите текст сообщения");
      return;
    }
    if (recipients <= 0) {
      window.alert("В выбранной воронке нет получателей");
      return;
    }
    const title = selected?.title || funnelId;
    if (
      !window.confirm(
        `Отправить сообщение ${recipients} клиент(ам) в «${title}»?\n\nЭто действие нельзя отменить.`
      )
    ) {
      return;
    }
    setSending(true);
    setResult(null);
    try {
      const res = await apiJson("/api/admin/broadcast", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ funnel_id: funnelId, text: t }),
      });
      setResult(res?.message || "Рассылка запущена");
      setText("");
    } catch (e) {
      window.alert(e instanceof Error ? e.message : String(e));
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="settingsBlock">
      <div className="sectionTitleRow">
        <span className="sectionTitle">Рассылка по воронке</span>
        <button
          type="button"
          className={`chip ${loading ? "active" : ""}`}
          disabled={loading}
          onClick={() => loadFunnels()}
        >
          {loading ? "…" : "Обновить"}
        </button>
      </div>

      <div className="crmMeta" style={{ marginTop: 10 }}>
        Сообщение уйдёт всем клиентам, у которых есть хотя бы одна сделка в выбранной воронке
        (для «База отказов» — включая старые сделки с воронкой nontarget). Только Telegram.
        Прогресс и итог придут вам в личку с ботом. Для фото/видео используйте команду{" "}
        <b>/spam</b> в боте.
      </div>

      {error ? <div style={{ marginTop: 10 }}>{pill(`Ошибка: ${error}`)}</div> : null}

      <div className="settingsForm" style={{ marginTop: 12 }}>
        <label className="crmKvLabel" htmlFor="broadcastFunnel">
          Воронка
        </label>
        <select
          id="broadcastFunnel"
          className="input"
          value={funnelId}
          disabled={loading || sending}
          onChange={(e) => setFunnelId(e.target.value)}
        >
          {funnels.map((f) => (
            <option key={String(f.id)} value={String(f.id)}>
              {f.title} ({f.recipients ?? 0})
            </option>
          ))}
        </select>

        <label className="crmKvLabel" htmlFor="broadcastText" style={{ marginTop: 12 }}>
          Текст сообщения
        </label>
        <textarea
          id="broadcastText"
          className="input"
          rows={6}
          maxLength={4096}
          placeholder="Текст для клиентов…"
          value={text}
          disabled={sending}
          onChange={(e) => setText(e.target.value)}
        />
        <div className="crmMeta" style={{ marginTop: 6 }}>
          {text.length}/4096 · получателей: {recipients}
        </div>

        <button
          type="button"
          className="smallBtn"
          style={{ marginTop: 12 }}
          disabled={sending || loading || recipients <= 0 || !text.trim()}
          onClick={handleSend}
        >
          {sending ? "Запуск…" : "Отправить рассылку"}
        </button>

        {result ? (
          <div className="crmMeta" style={{ marginTop: 10, color: "var(--tg-accent, #2481cc)" }}>
            {result}
          </div>
        ) : null}
      </div>
    </div>
  );
}
